module.exports = __webpack_public_path__ + "static/media/dashboard-workspace-app-application-layout-vertical-active.c9f95935.svg";